// Angular
import { CommonModule, DecimalPipe, registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// Core
import { CoreModule } from "./_core/core.module";
import { HighlightSearchPipe } from "./_core/pipes/highlight-search.pipe";
import { NumberSuffixPipe } from "./_core/pipes/number-suffix.pipe";

// Components
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { LeafletMarkerClusterModule } from "@asymmetrik/ngx-leaflet-markercluster";
import { SwiperModule } from "swiper/angular";

// Models

// Material
import { CdkTableModule } from "@angular/cdk/table";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

// PrimeNG
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from "primeng/confirmdialog";

// import ngx-translate and the http loader
import { HttpClient } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Shared
import { HeaderComponent } from "../../src/app/modules/shared/header/header.component";
import { LayoutComponent } from "./modules/shared/layout/layout.component";

import { ErrorComponent } from "./modules/shared/error/error.component";

// Locale settings
import localeEs from "@angular/common/locales/es";

// Components
import { PowerBIEmbedModule } from "powerbi-client-angular";
import { AuthService } from "./_core/providers/auth.service";
import { ApplicationDialogComponent } from "./modules/main/components/dialogs/application-dialog/application-dialog.component";
import { NoDigitDecimaNumberDirective } from "./modules/shared/directives/no-decimal-digit-number.directive";
import { TwoDigitDecimaNumberDirective } from "./modules/shared/directives/two-decimal-digit-number.directive";
import { LoaderComponent } from "./modules/shared/loader/loader.component";

registerLocaleData(localeEs, "es");

export function getConfigFromServer(config: AuthService) {
	return () => config.initializeAuth();
}

@NgModule({
	declarations: [
		NumberSuffixPipe,
		HighlightSearchPipe,
		LayoutComponent,
		HeaderComponent,
		ErrorComponent,
		LoaderComponent,
		ApplicationDialogComponent,
		TwoDigitDecimaNumberDirective,
		NoDigitDecimaNumberDirective,
	],
	imports: [
		InputNumberModule,
		ConfirmDialogModule,
		DropdownModule,
		CommonModule,
		CoreModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		NgbModule,
		RouterModule,
		TranslateModule,
		LeafletModule,
		LeafletMarkerClusterModule,
		MatButtonModule,
		MatFormFieldModule,
		MatAutocompleteModule,
		MatCardModule,
		MatIconModule,
		MatSidenavModule,
		MatListModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatSliderModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatDialogModule,
		MatTooltipModule,
		MatButtonToggleModule,
		MatTabsModule,
		MatTableModule,
		CdkTableModule,
		MatTooltipModule,
		MatPaginatorModule,
		MatSortModule,
		MatMenuModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatChipsModule,
		MatInputModule,
		MatCheckboxModule,
		MatTreeModule,
		MatProgressSpinnerModule,
		SwiperModule,
		PowerBIEmbedModule,
	],
	exports: [
		InputNumberModule,
		ConfirmDialogModule,
		DropdownModule,
		DecimalPipe,
		NumberSuffixPipe,
		HighlightSearchPipe,
		CommonModule,
		CoreModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		RouterModule,
		TranslateModule,
		LeafletModule,
		LeafletMarkerClusterModule,
		MatButtonModule,
		MatFormFieldModule,
		MatAutocompleteModule,
		MatCardModule,
		MatIconModule,
		MatSidenavModule,
		MatListModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatSliderModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatDialogModule,
		MatTooltipModule,
		MatButtonToggleModule,
		MatTableModule,
		CdkTableModule,
		MatTabsModule,
		MatTooltipModule,
		MatPaginatorModule,
		MatSortModule,
		MatMenuModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatChipsModule,
		MatInputModule,
		MatCheckboxModule,
		MatTreeModule,
		MatProgressSpinnerModule,
		SwiperModule,
		PowerBIEmbedModule,
		TwoDigitDecimaNumberDirective,
		NoDigitDecimaNumberDirective,
	],
	providers: [DecimalPipe, NumberSuffixPipe, HighlightSearchPipe],
})
export class SharedModule {}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
